import React from 'react';
import PropTypes from 'prop-types';

const ID = ({ data }) => {

  let id = "";

  if (data){
    id = data.toString();
  }

  return (
    <span>{id}</span>
  );
};

ID.propTypes = {
  data: PropTypes.number
};

export default ID;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Display/ID.js